import { render, staticRenderFns } from "./MailList.vue?vue&type=template&id=7ce3c5e7&"
import script from "./MailList.vue?vue&type=script&lang=js&"
export * from "./MailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports